import { useMemo } from 'react';

import { isToday, isWithinInterval, subDays } from 'date-fns';

import { ChatConversation } from './useChat';

export interface GroupedConversations {
  today: ChatConversation[];
  previous7Days: ChatConversation[];
  previous30Days: ChatConversation[];
  older: ChatConversation[];
}

export const useGroupedConversations = (
  conversations: ChatConversation[]
): GroupedConversations =>
  useMemo(() => {
    const now = new Date();
    const sevenDaysAgo = subDays(now, 7);
    const thirtyDaysAgo = subDays(now, 30);

    const groups: GroupedConversations = {
      today: [],
      previous7Days: [],
      previous30Days: [],
      older: [],
    };

    conversations.forEach((conversation) => {
      const updatedAt = new Date(conversation.updated_at);

      if (isToday(updatedAt)) {
        groups.today.push(conversation);
      } else if (
        isWithinInterval(updatedAt, { start: sevenDaysAgo, end: now })
      ) {
        groups.previous7Days.push(conversation);
      } else if (
        isWithinInterval(updatedAt, { start: thirtyDaysAgo, end: now })
      ) {
        groups.previous30Days.push(conversation);
      } else if (updatedAt < thirtyDaysAgo) {
        groups.older.push(conversation);
      }
    });

    return groups;
  }, [conversations]);
